import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import * as signalR from "@microsoft/signalr";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { UserIdleService } from "angular-user-idle";
import { Observable, interval, Subscription } from "rxjs";
import { environment } from "src/environments/environment";
import { HttpService } from "../core/service/http.service";
import { Prescription } from "./models/prescription";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  private connectionIsEstablished = false;
  private _hubConnection: HubConnection;
  public mySubscription: Subscription;
  connectionEstablished = new EventEmitter<Boolean>();
  messageReceived = new EventEmitter<Prescription>();
  addprescription = new EventEmitter<Prescription>();
  notificationRecived = new EventEmitter<any>();
  constructor(
    private httpService: HttpService,
    private router: Router,
    private userIdle: UserIdleService
  ) {
    this.createConnection();
    this.registerOnServerEvents();
    this.startConnection();
    this._hubConnection.onclose(() => {
      setTimeout(() => {
        this.startConnection();
      }, 5000);
    });
  }

  private createConnection() {
    this._hubConnection = new HubConnectionBuilder()
      .withUrl(environment.notifyUrl + "Notifier", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();
    this._hubConnection.serverTimeoutInMilliseconds = 600000;
  }

  private startConnection(): void {
    this._hubConnection
      .start()
      .then(() => {
        this.connectionIsEstablished = true;
        this._hubConnection.serverTimeoutInMilliseconds = 600000;
        this.connectionEstablished.emit(true);
      })
      .catch((err) => {
        this.startConnection();
      });
  }

  sendTestMessage() {
    const data = {
      Message: "test",
    };
    this._hubConnection.invoke("SendTestMessage", data);
  }

  registerOnServerEvents(): void {
    this._hubConnection.on("ReceivedPrescription", (data: any) => {
      this.messageReceived.emit(data);
    });

    this._hubConnection.on("AddPrescription", (data: any) => {
      this.addprescription.emit(data);
    });

    this._hubConnection.on("ReceivedNotification", (data: any) => {
      this.notificationRecived.emit(data);
    });
  }
  SendPrescription(prescription: Prescription) {
    this._hubConnection.invoke("SendPrescription", prescription);
  }
  AddPrescription(prescription: Prescription) {
    this._hubConnection.invoke("AddPrescription", prescription);
  }
  AddNotification(notificationDetails: any) {
    return this.httpService.post("notification/Add", notificationDetails);
  }
  UpdateNotification(notificationDetails: any) {
    return this.httpService.post("notification/Update", notificationDetails);
  }
  ListNotification(notificationDetails: any) {
    return this.httpService.post("notification/List", notificationDetails);
  }
  AddPortalNotification(notification: any) {
    this._hubConnection.invoke("AddNotification", notification);
  }

  openedConnectionAndSendMessage() {
    const source = interval(30000);
    this.mySubscription = source.subscribe((x) => {
      if (this.router.url.includes("signin")) {
        this.mySubscription.unsubscribe();
      } else {
        this.sendTestMessage();
      }
    });
  }
  restart() {
    this.userIdle.resetTimer();
  }
}
